import { ref } from 'vue';
import { trackEvent } from '../utils/analytics';

// Create a single shared reactive state
const isZenMode = ref(false);

export function useZenMode() {
  function toggleZenMode() {
    isZenMode.value = !isZenMode.value;
    try {
      trackEvent('Zen Mode Toggled', {
        enabled: isZenMode.value,
        timestamp: new Date().toISOString(),
      });
    } catch (err) {
      console.error('Failed to track Zen Mode toggle:', err);
    }
  }

  return {
    isZenMode,
    toggleZenMode,
  };
}
